/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Title1Inputs */

const id_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performa`)
};

const ms_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasi`)
};

const da_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ydelse`)
};

const de_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistung`)
};

const en_us2_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance`)
};

const es_es2_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento`)
};

const es_mx2_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento`)
};

const fil_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagganap`)
};

const fr_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance`)
};

const it_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestazioni`)
};

const hu_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmény`)
};

const nl_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestaties`)
};

const no_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ytelse`)
};

const pl_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydajność`)
};

const pt_br2_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance`)
};

const pt_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desempenho`)
};

const ro_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performanță`)
};

const fi_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suorituskyky`)
};

const sv_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestanda`)
};

const vi_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiệu suất`)
};

const tr_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performans`)
};

const cs_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výkon`)
};

const bg_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Производителност`)
};

const ru_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Производительность`)
};

const uk_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продуктивність`)
};

const ar_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأداء`)
};

const hi_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदर्शन`)
};

const th_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประสิทธิภาพ`)
};

const ja_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パフォーマンス`)
};

const zh_cn2_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表现`)
};

const zh_hant1_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance`)
};

const ko_components_performancetable_title1 = /** @type {(inputs: Components_Performancetable_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`성과`)
};

/**
* | output |
* | --- |
* | "Performance" |
*
* @param {Components_Performancetable_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_title1 = /** @type {((inputs?: Components_Performancetable_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_title1(inputs)
	if (locale === "ms") return ms_components_performancetable_title1(inputs)
	if (locale === "da") return da_components_performancetable_title1(inputs)
	if (locale === "de") return de_components_performancetable_title1(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_title1(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_title1(inputs)
	if (locale === "fil") return fil_components_performancetable_title1(inputs)
	if (locale === "fr") return fr_components_performancetable_title1(inputs)
	if (locale === "it") return it_components_performancetable_title1(inputs)
	if (locale === "hu") return hu_components_performancetable_title1(inputs)
	if (locale === "nl") return nl_components_performancetable_title1(inputs)
	if (locale === "no") return no_components_performancetable_title1(inputs)
	if (locale === "pl") return pl_components_performancetable_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_title1(inputs)
	if (locale === "pt") return pt_components_performancetable_title1(inputs)
	if (locale === "ro") return ro_components_performancetable_title1(inputs)
	if (locale === "fi") return fi_components_performancetable_title1(inputs)
	if (locale === "sv") return sv_components_performancetable_title1(inputs)
	if (locale === "vi") return vi_components_performancetable_title1(inputs)
	if (locale === "tr") return tr_components_performancetable_title1(inputs)
	if (locale === "cs") return cs_components_performancetable_title1(inputs)
	if (locale === "bg") return bg_components_performancetable_title1(inputs)
	if (locale === "ru") return ru_components_performancetable_title1(inputs)
	if (locale === "uk") return uk_components_performancetable_title1(inputs)
	if (locale === "ar") return ar_components_performancetable_title1(inputs)
	if (locale === "hi") return hi_components_performancetable_title1(inputs)
	if (locale === "th") return th_components_performancetable_title1(inputs)
	if (locale === "ja") return ja_components_performancetable_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_title1(inputs)
	return ko_components_performancetable_title1(inputs)
});
export { components_performancetable_title1 as "components.performanceTable.title" }